//core
// import React, { useState,useEffect,useContext } from 'react';
import React from "react";
import moment from "moment";
//Dashboard PRO
import Button from "components/CustomButtons/Button.jsx";
//component
import OSS from "ali-oss";
import { getOssClient } from 'shared/oss-conf';
const baseUrl = "http://v2cs-oss.oss-cn-beijing.aliyuncs.com/";

export default function UploadOss(props) {
  const inputRef = React.createRef();
  const handleClick = () => {
    // props.closeSnackbar()
    inputRef.current.click();
  };
  const handleChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) {
      //没有文件的时候不往下执行
      return;
    }
    const originName = file.name;
    //首先判断是否有两个.
    const fileNameArr = originName.split(".");
    if (fileNameArr.length > 2) {
      // 有两个以上元素说明文件名中包含.
      // props.openSnackbar("文件名不能包含特殊字符，请修改后上传", "warning");
      alert('文件名不能包含特殊字符，请修改后上传')
      return;
    }
    //再次判断文件名是否符合正则
    const regEn = /^[\u4e00-\u9fa5_\-()（）a-zA-Z0-9_]{1,30}$/;
    if (!regEn.test(fileNameArr[0])) {
      // props.openSnackbar(
      //   "文件名不能包含特殊字符且小于30个字符,请修改后上传",
      //   "warning"
      // );
      alert('文件名不能包含特殊字符且小于30个字符,请修改后上传')
      return;
    }

    const fileExtension = fileNameArr[fileNameArr.length - 1];
    const extensionCheck = [
      "jpg",
      "jpeg",
      "gif",
      "png",
      "bmp",
      "pdf",
      "doc",
      "docx",
    ];
    let count = 0;
    for (let m = 0; m < extensionCheck.length; m += 1) {
      // 挨个检查扩展名
      if (fileExtension.toLowerCase() !== extensionCheck[m]) {
        // 一旦不对就+1
        count += 1;
      } else {
        break;
      }
    }
    if (count === extensionCheck.length) {
      // 相等表示没一个是对的
      // props.openSnackbar("不支持当前上传的文件类型", "warning");
      alert('不支持当前上传的文件类型')
      return;
    }

    let fileName = moment().format("YYYY/MM/DD/HH/mm/ss/SSS/") + file.name;
    reader.readAsArrayBuffer(file);
    reader.onload = function (event) {
      let buffer = new OSS.Buffer(event.target.result);
      getOssClient().then((client) => {
        client.put(fileName, buffer).then(
          (res) => {
            // props.uploadSuccess(res);
            props.uploadSuccess(res.name);
          },
          (err) => {
            if (props.uploadError) {
              props.uploadError(err);
            }
          }
        );
      })
    };
  };

  // const whetherImg = name => {
  //   //检测是否为数组
  //   let fileExt = name.split('.')[1];
  //   const imgExt = ["png","jpg","jpeg","bmp","gif"];
  //   for (let index = 0; index < imgExt.length; index++) {
  //     if (fileExt === imgExt[index]) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  const showFileName = (allName) => {
    //路径处理一下，只显示文件名
    const tempArr = allName.split("/");
    return tempArr[tempArr.length - 1];
  };

  return (
    <React.Fragment>
      <div style={{ ...props.style }} className="fileinput text-center">
        <input
          id={props.type + "Upload"}
          ref={inputRef}
          type="file"
          onChange={handleChange}
        />
        <Button
          className={props.fileList.length > 0 ? props.btnClassName : ""}
          size="sm"
          onClick={() => handleClick()}
          style={{ marginRight: "5px", verticalAlign: "top" }}
          color={props.color ? props.color : "info5"}
        >
          选择文件
        </Button>
        {/* 展示区域 */}
        {props.fileList.length > 0
          ? props.fileList.map((k, key) => {
            return (
              <span
                key={key}
                style={{ display: "inline-block", marginRight: "5px" }}
              >
                <div>
                  <a
                    href={baseUrl + k}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {showFileName(k)}
                    {/* {whetherImg(k) ? <img height='120' src={(baseUrl + k)} alt='...'/> : k} */}
                  </a>
                </div>
                {props.disableDelete ? (
                  ""
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <Button size="sm" onClick={() => props.deleteImg(k)}>
                      删除
                    </Button>
                  </div>
                )}
              </span>
            );
          })
          : ""}
      </div>
    </React.Fragment>
  );
}
